// extracted by mini-css-extract-plugin
export default {"bottomNav":"App_bottomNav__igaJm","link":"App_link__cO21p","linkIcon":"App_linkIcon__w6ZXI","noMatch":"App_noMatch__xFAFm"};